import React, { useEffect } from 'react';

// 섹션 9: CTA Section을 원본 HTML과 완전히 동일하게 구현
const Section9: React.FC = () => {
  // 스크롤 애니메이션 초기화
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.scroll-animate');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // CTA 버튼 클릭 핸들러
  const handleCTAClick = () => {
    // 여기에 실제 체험하기 로직을 추가할 수 있습니다
    console.log('콘엑스 체험하기 클릭됨');
    // 예: window.location.href = '/trial' 또는 모달 열기 등
  };

  return (
    <section className="section cta-section scroll-animate" id="cta">
      {/* 배경 그리드 */}
      <div className="grid-background-cta"></div>
      
      {/* 데이터 플로우 */}
      <div className="data-flow-cta">
        <div className="flow-line-cta"></div>
        <div className="flow-line-cta"></div>
        <div className="flow-line-cta"></div>
        <div className="flow-line-cta"></div>
      </div>
      
      <div className="cta-inner">
        {/* 배경 패턴 */}
        <div className="pattern-background"></div>
        
        {/* 위젯 요소들 */}
        <div className="widget-elements">
          <div className="mini-widget"></div>
          <div className="mini-widget"></div>
          <div className="mini-widget"></div>
          <div className="mini-widget"></div>
        </div>
        
        {/* 메인 컨텐츠 */}
        <div className="cta-content">
          <div className="status-badge">
            <div className="status-indicator"></div>
            <span>시스템 상태: 온라인 • 모든 견적 시스템 정상 운영 중</span>
          </div>
          
          <h2 className="cta-title">
            <span className="dashboard-text">웹 기반 시스템</span>으로<br/>
            <span className="ai-accent">3일 무료체험</span><br/>
            일위대가 관리를 시작하세요
          </h2>
          
          <p className="cta-subtitle">
            실시간 데이터 관리와 웹 기반 시스템으로 업무 효율을 극대화하세요.<br/>
            전문가급 일위대가 관리를 즉시 확인하고 견적 작업 속도를 10배 빠르게 만들어보세요.
          </p>
          
          <div className="dashboard-stats">
            <div className="stat-widget">
              <div className="stat-icon">📊</div>
              <div className="stat-title">처리 속도</div>
              <div className="stat-value">92%</div>
            </div>
            <div className="stat-widget">
              <div className="stat-icon">⚡</div>
              <div className="stat-title">업무 효율</div>
              <div className="stat-value">10X</div>
            </div>
            <div className="stat-widget">
              <div className="stat-icon">🎯</div>
              <div className="stat-title">정확도</div>
              <div className="stat-value">99.9%</div>
            </div>
            <div className="stat-widget">
              <div className="stat-icon">💰</div>
              <div className="stat-title">비용 절감</div>
              <div className="stat-value">70%</div>
            </div>
          </div>
          
          <button className="cta-button" onClick={handleCTAClick}>
            🚀 콘엑스 체험하기
          </button>
          
          <div className="dashboard-preview">
            <div className="live-dot"></div>
            <span>실시간 견적 관리 • 24/7 모니터링 • 즉시 사용 가능</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section9;